import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useFormikContext } from "formik";
import AddButton from "../../buttons/button";
import {
  AlternativeIcon,
  PastBillsIcon,
  ProductDetailsIcon,
  StoriesIcon,
} from "../../../assets/icons/invoice-header-icons";

import { useHotkeys } from "../../helper-components/use-hotkeys";
import ItemsInputField from "../../forms/items-input-field";
import ItemsSelectField from "../../forms/items-select-field";
import { filterByTimePeriod } from "../../helper-components/data";
import FilterIcon from "../../../assets/icons/filter-icon";
import BatchIcon from "../../../assets/icons/batches-icons/batch-icon";
import BatchDetailsPanel from "./batch-details-panel";
import AuditLoadFilters from "./audit-load-filters-panel";

const StockAuditHeaderSection = ({
  selectedItem,
  setSelectedItem,
  qtyRef,
  disabled = false,
  page = "create",
  is_auto_batch,
  setBatchModalOpen,
  paymentPanel = false,
  initialValues = {},
}) => {
  const alternativesRef = useRef(null);
  const otherStoresRef = useRef(null);
  const proDetRef = useRef(null);
  const pastRef = useRef(null);

  useHotkeys("a", () => {
    if (alternativesRef.current && !paymentPanel) {
      alternativesRef.current.click();
    }
  });
  useHotkeys("o", () => {
    if (otherStoresRef.current) {
      otherStoresRef.current.click();
    }
  });
  useHotkeys("d", () => {
    if (proDetRef.current) {
      proDetRef.current.click();
    }
  });    
  useHotkeys("p", () => {
    if (pastRef.current && !paymentPanel) {
      pastRef.current.click();
    }
  });
  const [loadFilterPanel, setLoadFilterPanel] = useState(false);
  const [BatchDetSlidePanel, setBatchDetSlidePanel] = useState(false);

  return (
    <div className="min-h-[8rem] flex items-center w-full">
      <div className=" justify-between bg-[var(--add-billing-head-bg)] rounded-[8px] h-[87px] flex items-center px-3 w-full ">
        <div className="flex gap-3 items-end w-[50%]">
          <div className="w-[20%]">
            <ItemsInputField
              isRequired={false}
              labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
              inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
              type="date"
              disabled={true}
              name={`date`}
              label="Date"
              isLabelReq={true}
            />
          </div>
          <div className="w-[30%]">
            <ItemsSelectField
              options={filterByTimePeriod}
              placeholder="Select reason of audit"
              isRequired={true}
              labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
              inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
              type="text"
              disabled={disabled}
              name={`audit_type`}
              label="Audit Type"
              isLabelReq={true}
            />
          </div>
          <div className="w-[50%]">
            <ItemsInputField
              placeholder="Comments"
              isRequired={false}
              labelClass="min-h-[1.2rem] text-[var(--search-input-label-color)] text-[length:var(--search-label-font-size)] font-[var(--search-label-font-weight)]"
              inputClass="min-h-[40px] px-2 border border-[var(--search-input-border)] focus:outline-none focus:border-[var(--search-input-focus)] bg-[var(--search-input-bg)] text-[var(--search-input-color)] text-[length:var(--search-input-font-size)] font-[var(--search-input-font-weight)] border-radius input-field-no-spin-buttons"
              type="text"
              disabled={disabled}
              name={`comments`}
              label="Comments"
              isLabelReq={true}
              allowAll={true}
            />
          </div>
        </div>

        <div className="flex items-center gap-5">
          {page !== "view" && (
            <AddButton
              ref={alternativesRef}
              onclkFn={() => {
                setLoadFilterPanel(!loadFilterPanel);
              }}
              icon={<FilterIcon fill="var(--general-button-icon)" />}
              text={
                <>
                  Load With Filters <span className="opacity-50">(F)</span>
                </>
              }
              className={`flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] 
            bg-[var(--general-button-bg)] cursor-pointer 
            border border-[var(--general-button-border)] 
            hover:bg-[var(--general-button-bg)] ${
              !disabled
                ? "text-[var(--general-button-fg)]"
                : "text-[var(--general-button-disabled-fg)] opacity-60 pointer-events-none"
            }`}
            />
          )}
          <AddButton
            ref={otherStoresRef}
            onclkFn={() => {
              if (selectedItem?.itemid)
                setBatchDetSlidePanel(!BatchDetSlidePanel);
            }}
            icon={<BatchIcon fill="var(--general-button-icon)" />}
            text={
              <>
                Batch Details <span className="opacity-50">(B)</span>
              </>
            }
            className={`flex items-center px-[12px] h-[44px] whitespace-nowrap rounded-[8px] gap-[8px] 
            bg-[var(--general-button-bg)] cursor-pointer 
            border border-[var(--general-button-border)] 
            hover:bg-[var(--general-button-bg)] 
            text-[var(--general-button-fg)]`}
          />
        </div>
      </div>
      <BatchDetailsPanel
        setSelectedItem={setSelectedItem}
        selectedItem={selectedItem}
        open={BatchDetSlidePanel}
        setOpen={setBatchDetSlidePanel}
      />
      <AuditLoadFilters
        initialValues={initialValues}
        open={loadFilterPanel}
        setOpen={setLoadFilterPanel}
      />
    </div>
  );
};

export default StockAuditHeaderSection;
